import { pipe } from 'fp-ts/function';

import { Http } from '@catawiki/runtime-toolkit';

import { SellerProfileResponse } from '../types/user';
import { sellerProfileAPI } from '../constants/apiRoutes';

export function fetchSellerProfile() {
  return pipe(Http.get(sellerProfileAPI), Http.send<SellerProfileResponse>());
}
